// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-main-header-text {
  font-family: Roboto !important;
  font-weight: 700 !important;
  font-style: Bold !important;
  font-size: 20px !important;
  line-height: 30px !important;
  letter-spacing: 0px !important;
  color: #101828 !important;
}

.common-text-101828-16 {
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Bold !important;
  font-size: 16px !important;
  line-height: 30px !important;
  letter-spacing: 0px !important;
  color: #101828 !important;
}

.common-text-101828-14 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  letter-spacing: 0px !important;
  color: #101828 !important;
}

.common-text-101828-12 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 20px !important;
  letter-spacing: 0px !important;
  color: #101828 !important;
}

.common-text-101828-12-500 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 20px !important;
  letter-spacing: 0px !important;
  color: #101828 !important;
}

.common-text-101828-20 {
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Bold !important;
  font-size: 20px !important;
  line-height: 30px !important;
  letter-spacing: 0px !important;
  color: #101828 !important;
}

.common-card-styles {
  background: var(--Icon-Default-Default, #ffffff) !important;
  border-radius: 14px !important;
  border-width: 1px !important;
  border-top: 1px solid #e5e7eb !important;
  box-shadow: 0px 1px 2px -1px #0000001a !important;
  box-shadow: 0px 1px 3px 0px #0000001a !important;
  padding: 20px !important;
}

.common-sub-header-black-14 {
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Semi Bold !important;
  font-size: 14px !important;
  line-height: 21px !important;
  letter-spacing: 0px !important;
  color: #1e2939 !important;
}

.common-text-1E2939-12 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 19.5px;
  letter-spacing: 0px;
  color: #1e2939 !important;
}

.common-text-1E2939-14-500 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Regular !important;
  font-size: 14px !important;
  line-height: 19.5px;
  letter-spacing: 0px;
  color: #1e2939 !important;
}

.common-text-008236-12 {
  font-family: Roboto !important;
  font-weight: 700 !important;
  font-style: Bold !important;
  font-size: 12px !important;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  color: #008236 !important;
}

.common-button-green {
  height: 36px !important;
  border-radius: 14px !important;
  box-shadow: 0px 1px 2px -1px #0000001a !important;
  background: var(--Colors-Primary-500, #dcfce7) !important;
  box-shadow: 0px 1px 3px 0px #0000001a !important;
  border-color: transparent !important;
}

.common-data-labels-grey {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 11px !important;
  line-height: 16.5px !important;
  letter-spacing: 0.28px !important;
  text-transform: uppercase !important;
  color: #99a1af !important;
}

.common-text-101828-14 {
  font-family: Roboto !important;
  font-weight: 600;
  font-style: Semi Bold !important;
  font-size: 14px !important;
  line-height: 17.5px !important;
  letter-spacing: 0px !important;
  color: #101828 !important;
}

.common-text-364153-14 {
  font-family: Roboto;
  font-weight: 500;
  font-style: Regular;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #364153;
}

.common-text-364153-14-500 {
  font-family: Roboto;
  font-weight: 500;
  font-style: Regular;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #364153;
}

.common-text-101828-18-600 {
  font-family: Roboto !important;
  font-weight: 600;
  font-style: Semi Bold !important;
  font-size: 18px !important;
  line-height: 17.5px !important;
  letter-spacing: 0px !important;
  color: #101828 !important;
}

.common-text-0A0A0A80-12 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  color: #0a0a0a80 !important;
}

.common-data-value-black {
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Semi Bold !important;
  font-size: 14px !important;
  line-height: 21px !important;
  letter-spacing: 0px !important;
}

.common-action-items-text-grey {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 12px !important;
  line-height: 18px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #4a5565 !important;
}

.common-text-4a5565-12 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Medium !important;
  font-size: 12px !important;
  line-height: 18px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #4a5565 !important;
}

.common-action-items-text-red {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 12px !important;
  line-height: 18px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #d2042d !important;
}

.common-action-items-text-black-14 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 14px !important;
  line-height: 18px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #000 !important;
}

.common-action-items-text-grey-14 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 14px !important;
  line-height: 18px !important;
  letter-spacing: 0px !important;
  text-align: center;
  color: #4a5565 !important;
}

.common-text-99A1AF-14 {
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Semi Bold !important;
  font-size: 14px !important;
  line-height: 20px !important;
  letter-spacing: 0px !important;
  color: #99a1af !important;
}

.common-product-detail-text-grey-10 {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular !important;
  font-size: 10px !important;
  line-height: 15px !important;
  letter-spacing: 0.25px !important;
  text-transform: uppercase !important;
  color: #99a1af !important;
}

.common-product-detail-text-black-12 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 18px !important;
  letter-spacing: 0px !important;
  color: #364153 !important;
}

.campaign-action-icons {
  width: 14px !important;
  height: auto !important;
  cursor: pointer !important;
}

.common-divider-horizontal {
  width: 100% !important;
  height: 1px !important;
  background-color: #e5e5e5;
  margin: 2px 0 !important;
}

.common-text-color-red-13 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 13px !important;
  line-height: 19.5px !important;
  letter-spacing: 0px !important;
  color: #d2042d !important;
  text-decoration: none !important;
}

.common-text-color-black-13 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 13px !important;
  line-height: 19.5px !important;
  letter-spacing: 0px !important;
  color: #000 !important;
  text-decoration: none !important;
}

.common-campaign-details-text-black-22 {
  font-family: Roboto !important;
  font-weight: 700 !important;
  font-style: Bold !important;
  font-size: 22px !important;
  line-height: 33px !important;
  letter-spacing: 0px !important;
  color: #101828 !important;
}

.common-text-FFFFFF-12 {
  font-family: Roboto !important;
  font-weight: 700 !important;
  font-style: Bold !important;
  font-size: 12px !important;
  line-height: 16px;
  letter-spacing: 0px;
  color: #ffffff !important;
}

.common-text-101828-18 {
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Semi Bold !important;
  font-size: 12px !important;
  line-height: 16px;
  letter-spacing: 0px;
  font-style: Semi Bold;
  color: #101828;
}

.common-text-101828-14-500 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Semi Bold !important;
  font-size: 14px !important;
  line-height: 16px;
  letter-spacing: 0px;
  font-style: Semi Bold;
  color: #101828;
}

.oval-shape-red-color-badge {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 31px !important;
  height: 21px !important;
  border-radius: 33554400px !important;
  opacity: 1 !important;
  color: #ffffff !important;
  padding-left: 8px !important;
  background: var(--Colors-Primary-500, #d2042d) !important;
}

.billboard-image-container {
  position: relative !important;
}

.billboard-image-checkbox {
  position: absolute !important;
  top: 8px !important;
  left: 8px !important;
  z-index: 10 !important;
}

.common-checkbox-black .ant-checkbox:not(.ant-checkbox-checked) .ant-checkbox-inner {
  background-color: #6a7282 !important;
  border: 1px solid #6a7282;
}

.location-grey-text-12 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 18px !important;
  letter-spacing: 0px !important;
  color: #6a7282 !important;
}

.location-grey-container {
  display: flex !important;
  align-items: baseline !important;
  flex-direction: row !important;
  align-content: flex-start !important;
  gap: 5px !important;
}

.common-text-111827-14 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 14px !important;
  line-height: 18px !important;
  letter-spacing: 0px !important;
  color: #111827;
}

.margin-style {
  margin: 0px !important;
}

.available-oval-shape-badge {
  width: 73px !important;
  height: 25px !important;
  border-radius: 33554400px !important;
  opacity: 1 !important;
  padding-top: 4px !important;
  padding-right: 12px !important;
  padding-bottom: 4px !important;
  padding-left: 12px !important;
  background: #e6f9f0 !important;
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Semi Bold !important;
  font-size: 11px !important;
  line-height: 16.5px !important;
  letter-spacing: 0px !important;
  text-align: right !important;
  color: #1a7a4a !important;
}

.offer-oval-shape-badge {
  background: #fef3c7 !important;
  width: 73px;
  height: 25px !important;
  border-radius: 33554400px !important;
  opacity: 1 !important;
  padding-top: 4px !important;
  padding-right: 12px !important;
  padding-bottom: 4px !important;
  padding-left: 12px !important;
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Semi Bold !important;
  font-size: 11px !important;
  line-height: 16.5px !important;
  letter-spacing: 0px !important;
  text-align: right !important;
  color: #d97706 !important;
}

.offer-oval-shape-badge-width {
  width: auto !important;
}

.grey-color-text-99a1af-11 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 11px !important;
  line-height: 16.5px !important;
  letter-spacing: 0px !important;
  text-align: right !important;
  color: #99a1af !important;
}

.common-text-99a1af-12 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 16.5px !important;
  letter-spacing: 0px !important;
  color: #99a1af !important;
}

.common-text-D97706-12 {
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 16.5px !important;
  letter-spacing: 0px !important;
  color: #d97706 !important;
}

.common-text-99a1af-12-500 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 16.5px !important;
  letter-spacing: 0px !important;
  color: #99a1af !important;
}

.common-text-99a1af-14-500 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 16.5px !important;
  letter-spacing: 0px !important;
  color: #99a1af !important;
}

.global-billboard-input-feild-re-designed {
  height: 3.125rem;
  padding: 0.625rem 1.25rem 0rem 1.25rem !important;
  align-items: center;
  margin-top: 0;
  font-size: 12px;
  border-radius: 0.3125rem !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  background: #fcfcfc !important;
  border-color: #fcfcfc;
  font-family: "Roboto";
  box-shadow: none;
  font-weight: 600 !important;
}

.grey-color-text-4A5565-12 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Regular !important;
  font-size: 11px !important;
  line-height: 16.5px !important;
  letter-spacing: 0px !important;
  text-align: right !important;
  color: #4a5565 !important;
}

.common-price-value-text-color-red-20 {
  font-family: Roboto !important;
  font-weight: 700 !important;
  font-style: Bold !important;
  font-size: 20px !important;
  line-height: 30px !important;
  letter-spacing: 0px !important;
  text-align: right !important;
  color: var(--Colors-Primary-500, #d2042d) !important;
}

.common-text-92400E-14 {
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Bold !important;
  font-size: 14px !important;
  line-height: 30px !important;
  letter-spacing: 0px !important;
  color: #92400e !important;
}

.common-text-155dfc-12 {
  font-family: Roboto !important;
  font-weight: 700 !important;
  font-style: Bold !important;
  font-size: 12px !important;
  line-height: 12px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #155dfc !important;
}

.common-minus-oulined-circular-shape {
  width: 24px !important;
  height: 24px !important;
  border-radius: 33554400px !important;
  opacity: 1 !important;
  border-width: 1px !important;
  border-top: 1px solid #d1d5dc !important;
}

.border-radios-color-grey .ant-btn.ant-btn-circle .ant-btn {
  border-radius: 1px solid #d1d5dc !important;
}

.border-radios-color-grey .ant-btn.ant-btn-circle .ant-btn :hover {
  border-color: 1px solid #d1d5dc !important;
}

.common-text-D1D5DC-12 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 16px !important;
  letter-spacing: 0px !important;
  color: #d1d5dc !important;
}

.common-text-color-red-10 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 10px !important;
  line-height: 15px !important;
  letter-spacing: 0px !important;
  text-align: right !important;
  color: #d2042d !important;
}

.common-text-color-red-12-400 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 15px !important;
  letter-spacing: 0px !important;
  text-align: right !important;
  color: #d2042d !important;
}

.common-text-color-red-14 {
  font-family: Roboto !important;
  font-weight: 700 !important;
  font-style: Bold !important;
  font-size: 14px !important;
  line-height: 15px !important;
  letter-spacing: 0px !important;
  text-align: right !important;
  color: #d2042d !important;
}

.yellow-ai-insight-card {
  border-radius: 14px !important;
  border-width: 1px !important;
  padding: 16px !important;
  background: linear-gradient(135deg, #fffbeb 0%, #fff7ed 100%) !important;
  border-top: 1px solid #fee685 !important;
  box-shadow: 0px 1px 2px -1px #0000001a !important;
  box-shadow: 0px 1px 3px 0px #0000001a !important;
}

.ai-insight-text-color {
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Semi Bold !important;
  font-size: 12px !important;
  line-height: 18px !important;
  letter-spacing: 0px !important;
  color: #973c00 !important;
}

.ai-insight-sub-text {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 11px !important;
  line-height: 17.88px !important;
  letter-spacing: 0px !important;
  color: #bb4d00 !important;
}

.re-designed-text-white-13 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 13px !important;
  line-height: 19.5px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #ffff !important;
}

.common-text-white-14 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 14px !important;
  line-height: 19.5px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #ffff !important;
}

.common-button-red {
  height: 36px !important;
  border-radius: 14px !important;
  box-shadow: 0px 1px 2px -1px #0000001a !important;
  background: var(--Colors-Primary-500, #d2042d) !important;
  box-shadow: 0px 1px 3px 0px #0000001a !important;
  border-color: transparent !important;
}

.common-button-red-28 {
  height: 28px !important;
  border-radius: 14px !important;
  box-shadow: 0px 1px 2px -1px #0000001a !important;
  background: var(--Colors-Primary-500, #d2042d) !important;
  box-shadow: 0px 1px 3px 0px #0000001a !important;
  border-color: transparent !important;
}

.common-button-yellow {
  height: 36px !important;
  border-radius: 14px !important;
  box-shadow: 0px 1px 2px -1px #0000001a !important;
  background: #d97706 !important;
  color: #fff !important;
  box-shadow: 0px 1px 3px 0px #0000001a !important;
  border-color: transparent !important;
}

.common-button-grey {
  height: 36px !important;
  border-radius: 14px !important;
  background: #f3f4f6 !important;
  border-color: #d9d9d9 !important;
}

.common-text-6A7282-14 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 14px !important;
  line-height: 20px !important;
  letter-spacing: 0px !important;
  color: #6a7282 !important;
}

.common-text-6A7282-14 {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 14px !important;
  line-height: 20px !important;
  letter-spacing: 0px !important;
  color: #6a7282 !important;
}

.common-text-d2042d-14 {
  font-family: Roboto !important;
  font-weight: 700 !important;
  font-style: Medium !important;
  font-size: 14px !important;
  line-height: 19.5px !important;
  letter-spacing: 0px !important;
  color: #d2042d !important;
  text-decoration: none !important;
}

.common-text-E17100-12 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 16px;
  letter-spacing: 0px;
  color: #e17100 !important;
}

.common-text-344054-12 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 16px;
  letter-spacing: 0px;
  color: #344054 !important;
}

.common-text-ffffffb2-12 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 12px !important;
  line-height: 16px;
  letter-spacing: 0px;
  color: #ffffffb2 !important;
}

.common-text-ffff-14-400 {
  font-family: Roboto !important;
  font-weight: 400 !important;
  font-style: Regular !important;
  font-size: 14px !important;
  line-height: 16px;
  letter-spacing: 0px;
  color: #fff !important;
}

.common-button-16a34a12 {
  color: #16a34a !important;
  background: #16a34a12 !important;
}

.common-button-radius {
  height: 30px !important;
  border-radius: 8px !important;
}

.common-offer-action-button {
  height: 28px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #d9dee7 !important;
  border-radius: 14px;
  background: #ffffff !important;
  color: #344054 !important;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* Hover */
.common-offer-action-button:hover {
  background: #f8fafc;
  border-color: #98a2b3;
  color: #1d2939;
}

/* Icon */
.common-offer-action-button .anticon {
  font-size: 14px;
}

.common-offer-action-button-success {
  border-color: #16a34a !important;
  color: #16a34a !important;
  background: #16a34a12 !important;
}

.common-offer-action-button-success:hover {
  border-color: #4ade80;
  color: #15803d;
  background: #dcfce7;
}

.common-offer-action-button-danger {
  border-color: #d9dee7;
  color: #667085;
  background: #ffffff;
}

.common-offer-action-button-danger:hover {
  border-color: #fca5a5;
  color: #dc2626;
  background: #fef2f2;
}

@media (max-width: 768px) {
  .common-campaign-details-text-black-22 {
    font-size: 14px !important;
  }

  .common-data-value-black {
    font-size: 12px !important;
  }

  .common-text-white-13 {
    font-size: 13px !important;
  }

  .common-action-items-text-black-14 {
    font-size: 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/GlobalStyle.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2DAA2D;EAC3D,8BAA8B;EAC9B,4BAA4B;EAC5B,wCAAwC;EACxC,iDAAiD;EACjD,gDAAgD;EAChD,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,iDAAiD;EACjD,yDAAyD;EACzD,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,iCAAiC;EACjC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;EACvB,oCAAoC;EACpC,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,mEAAmE;EACnE,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,qBAAqB;EACrB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;EACxB,wEAAwE;EACxE,wCAAwC;EACxC,iDAAiD;EACjD,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,iDAAiD;EACjD,yDAAyD;EACzD,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,iDAAiD;EACjD,yDAAyD;EACzD,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,iDAAiD;EACjD,8BAA8B;EAC9B,sBAAsB;EACtB,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oCAAoC;EACpC,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".common-main-header-text {\n  font-family: Roboto !important;\n  font-weight: 700 !important;\n  font-style: Bold !important;\n  font-size: 20px !important;\n  line-height: 30px !important;\n  letter-spacing: 0px !important;\n  color: #101828 !important;\n}\n\n.common-text-101828-16 {\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Bold !important;\n  font-size: 16px !important;\n  line-height: 30px !important;\n  letter-spacing: 0px !important;\n  color: #101828 !important;\n}\n\n.common-text-101828-14 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-size: 16px !important;\n  line-height: 20px !important;\n  letter-spacing: 0px !important;\n  color: #101828 !important;\n}\n\n.common-text-101828-12 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-size: 12px !important;\n  line-height: 20px !important;\n  letter-spacing: 0px !important;\n  color: #101828 !important;\n}\n\n.common-text-101828-12-500 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-size: 12px !important;\n  line-height: 20px !important;\n  letter-spacing: 0px !important;\n  color: #101828 !important;\n}\n\n.common-text-101828-20 {\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Bold !important;\n  font-size: 20px !important;\n  line-height: 30px !important;\n  letter-spacing: 0px !important;\n  color: #101828 !important;\n}\n\n.common-card-styles {\n  background: var(--Icon-Default-Default, #ffffff) !important;\n  border-radius: 14px !important;\n  border-width: 1px !important;\n  border-top: 1px solid #e5e7eb !important;\n  box-shadow: 0px 1px 2px -1px #0000001a !important;\n  box-shadow: 0px 1px 3px 0px #0000001a !important;\n  padding: 20px !important;\n}\n\n.common-sub-header-black-14 {\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Semi Bold !important;\n  font-size: 14px !important;\n  line-height: 21px !important;\n  letter-spacing: 0px !important;\n  color: #1e2939 !important;\n}\n\n.common-text-1E2939-12 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 19.5px;\n  letter-spacing: 0px;\n  color: #1e2939 !important;\n}\n\n.common-text-1E2939-14-500 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Regular !important;\n  font-size: 14px !important;\n  line-height: 19.5px;\n  letter-spacing: 0px;\n  color: #1e2939 !important;\n}\n\n.common-text-008236-12 {\n  font-family: Roboto !important;\n  font-weight: 700 !important;\n  font-style: Bold !important;\n  font-size: 12px !important;\n  line-height: 16px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: #008236 !important;\n}\n\n.common-button-green {\n  height: 36px !important;\n  border-radius: 14px !important;\n  box-shadow: 0px 1px 2px -1px #0000001a !important;\n  background: var(--Colors-Primary-500, #dcfce7) !important;\n  box-shadow: 0px 1px 3px 0px #0000001a !important;\n  border-color: transparent !important;\n}\n\n.common-data-labels-grey {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 11px !important;\n  line-height: 16.5px !important;\n  letter-spacing: 0.28px !important;\n  text-transform: uppercase !important;\n  color: #99a1af !important;\n}\n\n.common-text-101828-14 {\n  font-family: Roboto !important;\n  font-weight: 600;\n  font-style: Semi Bold !important;\n  font-size: 14px !important;\n  line-height: 17.5px !important;\n  letter-spacing: 0px !important;\n  color: #101828 !important;\n}\n\n.common-text-364153-14 {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Regular;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #364153;\n}\n\n.common-text-364153-14-500 {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Regular;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #364153;\n}\n\n.common-text-101828-18-600 {\n  font-family: Roboto !important;\n  font-weight: 600;\n  font-style: Semi Bold !important;\n  font-size: 18px !important;\n  line-height: 17.5px !important;\n  letter-spacing: 0px !important;\n  color: #101828 !important;\n}\n\n.common-text-0A0A0A80-12 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular;\n  font-size: 12px;\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: #0a0a0a80 !important;\n}\n\n.common-data-value-black {\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Semi Bold !important;\n  font-size: 14px !important;\n  line-height: 21px !important;\n  letter-spacing: 0px !important;\n}\n\n.common-action-items-text-grey {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 12px !important;\n  line-height: 18px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #4a5565 !important;\n}\n\n.common-text-4a5565-12 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Medium !important;\n  font-size: 12px !important;\n  line-height: 18px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #4a5565 !important;\n}\n\n.common-action-items-text-red {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 12px !important;\n  line-height: 18px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #d2042d !important;\n}\n\n.common-action-items-text-black-14 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 14px !important;\n  line-height: 18px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #000 !important;\n}\n\n.common-action-items-text-grey-14 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 14px !important;\n  line-height: 18px !important;\n  letter-spacing: 0px !important;\n  text-align: center;\n  color: #4a5565 !important;\n}\n\n.common-text-99A1AF-14 {\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Semi Bold !important;\n  font-size: 14px !important;\n  line-height: 20px !important;\n  letter-spacing: 0px !important;\n  color: #99a1af !important;\n}\n\n.common-product-detail-text-grey-10 {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular !important;\n  font-size: 10px !important;\n  line-height: 15px !important;\n  letter-spacing: 0.25px !important;\n  text-transform: uppercase !important;\n  color: #99a1af !important;\n}\n\n.common-product-detail-text-black-12 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 18px !important;\n  letter-spacing: 0px !important;\n  color: #364153 !important;\n}\n\n.campaign-action-icons {\n  width: 14px !important;\n  height: auto !important;\n  cursor: pointer !important;\n}\n\n.common-divider-horizontal {\n  width: 100% !important;\n  height: 1px !important;\n  background-color: #e5e5e5;\n  margin: 2px 0 !important;\n}\n\n.common-text-color-red-13 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 13px !important;\n  line-height: 19.5px !important;\n  letter-spacing: 0px !important;\n  color: #d2042d !important;\n  text-decoration: none !important;\n}\n\n.common-text-color-black-13 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 13px !important;\n  line-height: 19.5px !important;\n  letter-spacing: 0px !important;\n  color: #000 !important;\n  text-decoration: none !important;\n}\n\n.common-campaign-details-text-black-22 {\n  font-family: Roboto !important;\n  font-weight: 700 !important;\n  font-style: Bold !important;\n  font-size: 22px !important;\n  line-height: 33px !important;\n  letter-spacing: 0px !important;\n  color: #101828 !important;\n}\n\n.common-text-FFFFFF-12 {\n  font-family: Roboto !important;\n  font-weight: 700 !important;\n  font-style: Bold !important;\n  font-size: 12px !important;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #ffffff !important;\n}\n\n.common-text-101828-18 {\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Semi Bold !important;\n  font-size: 12px !important;\n  line-height: 16px;\n  letter-spacing: 0px;\n  font-style: Semi Bold;\n  color: #101828;\n}\n\n.common-text-101828-14-500 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Semi Bold !important;\n  font-size: 14px !important;\n  line-height: 16px;\n  letter-spacing: 0px;\n  font-style: Semi Bold;\n  color: #101828;\n}\n\n.oval-shape-red-color-badge {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 31px !important;\n  height: 21px !important;\n  border-radius: 33554400px !important;\n  opacity: 1 !important;\n  color: #ffffff !important;\n  padding-left: 8px !important;\n  background: var(--Colors-Primary-500, #d2042d) !important;\n}\n\n.billboard-image-container {\n  position: relative !important;\n}\n\n.billboard-image-checkbox {\n  position: absolute !important;\n  top: 8px !important;\n  left: 8px !important;\n  z-index: 10 !important;\n}\n\n.common-checkbox-black .ant-checkbox:not(.ant-checkbox-checked) .ant-checkbox-inner {\n  background-color: #6a7282 !important;\n  border: 1px solid #6a7282;\n}\n\n.location-grey-text-12 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 18px !important;\n  letter-spacing: 0px !important;\n  color: #6a7282 !important;\n}\n\n.location-grey-container {\n  display: flex !important;\n  align-items: baseline !important;\n  flex-direction: row !important;\n  align-content: flex-start !important;\n  gap: 5px !important;\n}\n\n.common-text-111827-14 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 14px !important;\n  line-height: 18px !important;\n  letter-spacing: 0px !important;\n  color: #111827;\n}\n\n.margin-style {\n  margin: 0px !important;\n}\n\n.available-oval-shape-badge {\n  width: 73px !important;\n  height: 25px !important;\n  border-radius: 33554400px !important;\n  opacity: 1 !important;\n  padding-top: 4px !important;\n  padding-right: 12px !important;\n  padding-bottom: 4px !important;\n  padding-left: 12px !important;\n  background: #e6f9f0 !important;\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Semi Bold !important;\n  font-size: 11px !important;\n  line-height: 16.5px !important;\n  letter-spacing: 0px !important;\n  text-align: right !important;\n  color: #1a7a4a !important;\n}\n\n.offer-oval-shape-badge {\n  background: #fef3c7 !important;\n  width: 73px;\n  height: 25px !important;\n  border-radius: 33554400px !important;\n  opacity: 1 !important;\n  padding-top: 4px !important;\n  padding-right: 12px !important;\n  padding-bottom: 4px !important;\n  padding-left: 12px !important;\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Semi Bold !important;\n  font-size: 11px !important;\n  line-height: 16.5px !important;\n  letter-spacing: 0px !important;\n  text-align: right !important;\n  color: #d97706 !important;\n}\n\n.offer-oval-shape-badge-width {\n  width: auto !important;\n}\n\n.grey-color-text-99a1af-11 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 11px !important;\n  line-height: 16.5px !important;\n  letter-spacing: 0px !important;\n  text-align: right !important;\n  color: #99a1af !important;\n}\n\n.common-text-99a1af-12 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 16.5px !important;\n  letter-spacing: 0px !important;\n  color: #99a1af !important;\n}\n\n.common-text-D97706-12 {\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 16.5px !important;\n  letter-spacing: 0px !important;\n  color: #d97706 !important;\n}\n\n.common-text-99a1af-12-500 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 16.5px !important;\n  letter-spacing: 0px !important;\n  color: #99a1af !important;\n}\n\n.common-text-99a1af-14-500 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 16.5px !important;\n  letter-spacing: 0px !important;\n  color: #99a1af !important;\n}\n\n.global-billboard-input-feild-re-designed {\n  height: 3.125rem;\n  padding: 0.625rem 1.25rem 0rem 1.25rem !important;\n  align-items: center;\n  margin-top: 0;\n  font-size: 12px;\n  border-radius: 0.3125rem !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  background: #fcfcfc !important;\n  border-color: #fcfcfc;\n  font-family: \"Roboto\";\n  box-shadow: none;\n  font-weight: 600 !important;\n}\n\n.grey-color-text-4A5565-12 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Regular !important;\n  font-size: 11px !important;\n  line-height: 16.5px !important;\n  letter-spacing: 0px !important;\n  text-align: right !important;\n  color: #4a5565 !important;\n}\n\n.common-price-value-text-color-red-20 {\n  font-family: Roboto !important;\n  font-weight: 700 !important;\n  font-style: Bold !important;\n  font-size: 20px !important;\n  line-height: 30px !important;\n  letter-spacing: 0px !important;\n  text-align: right !important;\n  color: var(--Colors-Primary-500, #d2042d) !important;\n}\n\n.common-text-92400E-14 {\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Bold !important;\n  font-size: 14px !important;\n  line-height: 30px !important;\n  letter-spacing: 0px !important;\n  color: #92400e !important;\n}\n\n.common-text-155dfc-12 {\n  font-family: Roboto !important;\n  font-weight: 700 !important;\n  font-style: Bold !important;\n  font-size: 12px !important;\n  line-height: 12px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #155dfc !important;\n}\n\n.common-minus-oulined-circular-shape {\n  width: 24px !important;\n  height: 24px !important;\n  border-radius: 33554400px !important;\n  opacity: 1 !important;\n  border-width: 1px !important;\n  border-top: 1px solid #d1d5dc !important;\n}\n\n.border-radios-color-grey .ant-btn.ant-btn-circle .ant-btn {\n  border-radius: 1px solid #d1d5dc !important;\n}\n\n.border-radios-color-grey .ant-btn.ant-btn-circle .ant-btn :hover {\n  border-color: 1px solid #d1d5dc !important;\n}\n\n.common-text-D1D5DC-12 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 16px !important;\n  letter-spacing: 0px !important;\n  color: #d1d5dc !important;\n}\n\n.common-text-color-red-10 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 10px !important;\n  line-height: 15px !important;\n  letter-spacing: 0px !important;\n  text-align: right !important;\n  color: #d2042d !important;\n}\n\n.common-text-color-red-12-400 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 15px !important;\n  letter-spacing: 0px !important;\n  text-align: right !important;\n  color: #d2042d !important;\n}\n\n.common-text-color-red-14 {\n  font-family: Roboto !important;\n  font-weight: 700 !important;\n  font-style: Bold !important;\n  font-size: 14px !important;\n  line-height: 15px !important;\n  letter-spacing: 0px !important;\n  text-align: right !important;\n  color: #d2042d !important;\n}\n\n.yellow-ai-insight-card {\n  border-radius: 14px !important;\n  border-width: 1px !important;\n  padding: 16px !important;\n  background: linear-gradient(135deg, #fffbeb 0%, #fff7ed 100%) !important;\n  border-top: 1px solid #fee685 !important;\n  box-shadow: 0px 1px 2px -1px #0000001a !important;\n  box-shadow: 0px 1px 3px 0px #0000001a !important;\n}\n\n.ai-insight-text-color {\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Semi Bold !important;\n  font-size: 12px !important;\n  line-height: 18px !important;\n  letter-spacing: 0px !important;\n  color: #973c00 !important;\n}\n\n.ai-insight-sub-text {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 11px !important;\n  line-height: 17.88px !important;\n  letter-spacing: 0px !important;\n  color: #bb4d00 !important;\n}\n\n.re-designed-text-white-13 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 13px !important;\n  line-height: 19.5px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #ffff !important;\n}\n\n.common-text-white-14 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 14px !important;\n  line-height: 19.5px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #ffff !important;\n}\n\n.common-button-red {\n  height: 36px !important;\n  border-radius: 14px !important;\n  box-shadow: 0px 1px 2px -1px #0000001a !important;\n  background: var(--Colors-Primary-500, #d2042d) !important;\n  box-shadow: 0px 1px 3px 0px #0000001a !important;\n  border-color: transparent !important;\n}\n\n.common-button-red-28 {\n  height: 28px !important;\n  border-radius: 14px !important;\n  box-shadow: 0px 1px 2px -1px #0000001a !important;\n  background: var(--Colors-Primary-500, #d2042d) !important;\n  box-shadow: 0px 1px 3px 0px #0000001a !important;\n  border-color: transparent !important;\n}\n\n.common-button-yellow {\n  height: 36px !important;\n  border-radius: 14px !important;\n  box-shadow: 0px 1px 2px -1px #0000001a !important;\n  background: #d97706 !important;\n  color: #fff !important;\n  box-shadow: 0px 1px 3px 0px #0000001a !important;\n  border-color: transparent !important;\n}\n\n.common-button-grey {\n  height: 36px !important;\n  border-radius: 14px !important;\n  background: #f3f4f6 !important;\n  border-color: #d9d9d9 !important;\n}\n\n.common-text-6A7282-14 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 14px !important;\n  line-height: 20px !important;\n  letter-spacing: 0px !important;\n  color: #6a7282 !important;\n}\n\n.common-text-6A7282-14 {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 14px !important;\n  line-height: 20px !important;\n  letter-spacing: 0px !important;\n  color: #6a7282 !important;\n}\n\n.common-text-d2042d-14 {\n  font-family: Roboto !important;\n  font-weight: 700 !important;\n  font-style: Medium !important;\n  font-size: 14px !important;\n  line-height: 19.5px !important;\n  letter-spacing: 0px !important;\n  color: #d2042d !important;\n  text-decoration: none !important;\n}\n\n.common-text-E17100-12 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #e17100 !important;\n}\n\n.common-text-344054-12 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #344054 !important;\n}\n\n.common-text-ffffffb2-12 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 12px !important;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #ffffffb2 !important;\n}\n\n.common-text-ffff-14-400 {\n  font-family: Roboto !important;\n  font-weight: 400 !important;\n  font-style: Regular !important;\n  font-size: 14px !important;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #fff !important;\n}\n\n.common-button-16a34a12 {\n  color: #16a34a !important;\n  background: #16a34a12 !important;\n}\n\n.common-button-radius {\n  height: 30px !important;\n  border-radius: 8px !important;\n}\n\n.common-offer-action-button {\n  height: 28px;\n  padding: 0 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 1px solid #d9dee7 !important;\n  border-radius: 14px;\n  background: #ffffff !important;\n  color: #344054 !important;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n/* Hover */\n.common-offer-action-button:hover {\n  background: #f8fafc;\n  border-color: #98a2b3;\n  color: #1d2939;\n}\n\n/* Icon */\n.common-offer-action-button .anticon {\n  font-size: 14px;\n}\n\n.common-offer-action-button-success {\n  border-color: #16a34a !important;\n  color: #16a34a !important;\n  background: #16a34a12 !important;\n}\n\n.common-offer-action-button-success:hover {\n  border-color: #4ade80;\n  color: #15803d;\n  background: #dcfce7;\n}\n\n.common-offer-action-button-danger {\n  border-color: #d9dee7;\n  color: #667085;\n  background: #ffffff;\n}\n\n.common-offer-action-button-danger:hover {\n  border-color: #fca5a5;\n  color: #dc2626;\n  background: #fef2f2;\n}\n\n@media (max-width: 768px) {\n  .common-campaign-details-text-black-22 {\n    font-size: 14px !important;\n  }\n\n  .common-data-value-black {\n    font-size: 12px !important;\n  }\n\n  .common-text-white-13 {\n    font-size: 13px !important;\n  }\n\n  .common-action-items-text-black-14 {\n    font-size: 12px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
